module.exports = __webpack_public_path__ + "img/party.2cefe600.gif";